import axios from '@dap/shared-utils/http';

const BASE_API = '/coach/api/tools/complaint-handle';

export default {
    getTableList (params) {
        return axios.post(BASE_API, params);
    },

    // 上传excel
    uploadExcel (params) {
        return axios.post('/coach/api/tools/complaint-upload', params, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    // 删除文件
    deleteExcel (params) {
        return axios.delete(BASE_API, { data: params });
    },

    // 获取用户id, name
    getUserList (params = {}) {
        params.status = 1;
        return axios.get('/coach/api/dap_user_id', { params });
    },

    // 渠道数据
    getSpreadList (params = {}) {
        params.is_deduplicate = 1;
        return axios.get('/coach/api/dap_spreader_names', { params });
    },
};
